export const reverseSizeMap = {
    male: { 32: 'XXS', 34: 'XS', 36: 'S', 38: 'M', 40: 'L', 42: 'XL', 44: 'XXL', 46: 'XXXL' },
    female: { 30: 'XXS', 32: 'XS', 34: 'S', 36: 'M', 38: 'L', 40: 'XL', 42: 'XXL', 44: 'XXXL' },
    kid: { 24: 'XXS', 26: 'XS', 28: 'S', 30: 'M', 32: 'L', 34: 'XL', 36: 'XXL', 38: 'XXXL' },
    unisex: { 31: 'XXS', 33: 'XS', 35: 'S', 37: 'M', 39: 'L', 41: 'XL', 43: 'XXL', 45: 'XXXL' }
};